import React, { useState, useEffect } from "react";

// others
import dayjs from "dayjs";
import { configKeys } from "../BookingForm/components/utils";
import { Loading } from "../BookingForm/components/modalContent";
import { useDispatch, useSelector } from "react-redux";
import { getKycDetailsService } from "../BookingForm/ducks/services";
import { useParams, useLocation } from "react-router-dom";
import DashboardLayout from "../../molecules/DashboardLayout";
import { disableEditButton } from "../BookingForm/components/utils";
import TerminationDetail from "./Components/TerminationDetail";
import { DocList, LeaseTerms, TenantDetails, PaymentSchedule } from "../BookingForm/components/view";
import {
  getConfigData,
  getLandlordUsers,
  getBookingDetail,
  clearBookingForm,
  getBookingUnitDetail,
  getTemplateDocuments,
  getParkingBays,
} from "../BookingForm/ducks/actions";
import { Modal, Collapse, ActionHeader, BookingDetailsCard as Card } from "../BookingForm/components";
import { Checklist, Notes, SplitLayout, TenantBankDetails } from "../../organism";
import { useGetOrganization } from "../../../api/v1";

let initialState = {
  load: false,
  visible: false,
  kycDetails: [],
  isKyc: true,
  attachDoc: {},
  modalPayload: {
    iKey: "",
    title: "",
    open: false,
    extraText: "",
  },
};

function TerminationProcess() {
  // hooks initialization
  const { state } = useLocation();
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const { organization } = useGetOrganization();

  const [sendSettlementReport, setSendSettlementReport] = useState(false);
  // redux states
  let { bookingDetails } = useSelector((state: any) => state.newBooking);
  let { refresh_renwal } = useSelector((state: any) => state.newBooking);

  // states
  const [{ load, isKyc, visible, modalPayload, kycDetails, attachDoc }, setState] = useState(initialState);
  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  useEffect(() => {
    if (leaseId) dispatch(getBookingDetail(leaseId + `?moveout=yes`));
    dispatch(getConfigData(configKeys));
    dispatch(getTemplateDocuments());

    return () => {
      dispatch(clearBookingForm());
    };
  }, [refresh_renwal]);

  useEffect(() => {
    const unitId = state?.selectedUnit?.unitId || bookingDetails?.unitId;
    const propertyId = state?.selectedProperty?.propertyId || bookingDetails?.propertyId;
    dispatch(getLandlordUsers(propertyId));
    dispatch(getParkingBays({ propertyId: propertyId }));

    if (unitId) {
      dispatch(getBookingUnitDetail(unitId));
      getKycDetails(unitId); // for bug:
    }
    if (Object.keys(bookingDetails)?.length > 0 && bookingDetails?.leaseStatus === "active" && state?.renewal) {
      const leaseTerms = {
        ...bookingDetails.leaseTerms,
        ...{
          leaseStartDate: dayjs(bookingDetails.leaseTerms.leaseEndDate).add(1, "day").toISOString(),
          leaseEndDate: dayjs(bookingDetails.leaseTerms.leaseEndDate).add(1, "year").toISOString(),
        },
      };

      bookingDetails["leaseTerms"] = {
        ...bookingDetails.leaseTerms,
        ...leaseTerms,
      };
    }
  }, [bookingDetails]);
  //  for user story 8455
  const [renewalFormConform, setRenewalFormConfirm] = useState<Boolean>(false);

  const handleEditPress = (key: string, renewalConform = null) => {
    let payload: any = { ...modalPayload };
    setRenewalFormConfirm(renewalConform);

    switch (key) {
      case "1":
        payload = {
          iKey: "1",
          title: "Tenant Details",
          extraText: "Enter an email address to look for an existing tenant or add a new one.",
          kycDetails, //added for bug: 7498,
        };
        break;
      case "2":
        payload = {
          iKey: "2",
          extraText: "",
          title: "Lease Terms",
        };
        break;
      case "3":
        payload = {
          iKey: "3",
          extraText: "",
          title: "Edit Payment Schedule",
        };
        break;
      case "5":
        payload = {
          iKey: "5",
          extraText: "",
          title: "Add Payment",
        };
        break;
      case "6":
        payload = {
          iKey: "6",
          extraText: "",
          width: "450px",
          title: "Request Documents",
        };
        break;
      case "7":
        payload = {
          iKey: "7",
          extraText: "",
          width: "80%",
          className: "generate-modal",
          title: "Generate Document from Template",
        };
        break;
      case "8":
        payload = {
          iKey: "8",
          width: "80%",
          title: "Change Payment Plan",
          extraText: "",
          //   "You can add a new payment plan, edit, or disable an existing payment plan. If you add or edit a payment plan, you\nneed to send an approval request.",
        };
        break;
      case "11":
        payload = {
          iKey: "11",
          width: "80%",
          extraText: "",
          title: "Change History",
        };
        break;
      case "15":
        payload = {
          iKey: "15",
          width: "600px",
          extraText: "",
          title: "Attach Docs",
          attachDoc,
        };
        break;
      case "17":
        payload = {
          iKey: "17",
          extraText: "",
          title: "Move-out Summary",
        };
        break;
      case "move-out-breakdown":
        payload = {
          iKey: "move-out-breakdown",
          width: "50%",
          extraText: "",
          title: "Move-out Breakdown",
        };
        break;
      case "40":
        payload = {
          iKey: "40",
          width: "1000px",
          extraText: "",
          title: "Lease Configuration",
          // attachDoc,
        };
        break;
      case "custom-fields":
        payload = {
          iKey: "custom-fields",
          width: "50%",
          extraText: "",
          title: "Custom Fields",
        };
        break;
      case "financial-dimensions":
        payload = {
          iKey: "financial-dimensions",
          width: "50%",
          extraText: "",
          title: "Financial Dimensions",
        };
        break;
    }

    updateState({ modalPayload: { ...payload, ...{ open: true } } });
  };

  const getKycDetails = async (unitId: string) => {
    try {
      const response = await getKycDetailsService(unitId);
      if (response?.length > 0) updateState({ isKyc: false, kycDetails: response });
      else updateState({ isKyc: false, kycDetails: [] });
    } catch (error) {
      updateState({ isKyc: false, kycDetails: [] });
    }
  };

  const disable = disableEditButton(bookingDetails, state?.renewal);

  let disabledStatus = ["awaiting_payment", "awaiting_refund", "settled"];

  return (
    <DashboardLayout load={load} className="bf-main-content">
      <Loading visible={visible} />

      <ActionHeader
        label="Move-out"
        renewal={state?.renewal || bookingDetails?.leaseType === "renewal"}
        booking={bookingDetails}
        parentState={updateState}
        actions={true}
        moveOutScreen={true}
        setSendSettlementReport={setSendSettlementReport}
      />
      <SplitLayout>
        <SplitLayout.Content style={{ flex: 1 }}>
          <Card
            booking={bookingDetails}
            renewal={state?.renewal || bookingDetails?.leaseType === "renewal"}
            // moveOutScreen = {true}
            handleChangeHistory={handleEditPress}
            // setShowCheckList={setShowCheckList}
          />

          <Collapse
            key="1"
            iKey="1"
            header="Tenant Details"
            modalKey={modalPayload.iKey}
            disable={true}
            handleEditPress={handleEditPress}
          >
            <TenantDetails kycDetails={kycDetails} />
          </Collapse>

          <Collapse
            key="2"
            iKey="2"
            header="Lease Terms"
            modalKey={modalPayload.iKey}
            disable={true}
            handleEditPress={handleEditPress}
          >
            <LeaseTerms
              contractNumber={bookingDetails?.ejari?.contractNumber}
              booking={bookingDetails}
              renewal={state?.renewal || bookingDetails?.leaseType === "renewal"}
            />
          </Collapse>

          <Collapse
            key="17"
            iKey="17"
            header="Move-out Summary"
            modalKey={modalPayload.iKey}
            disable={
              bookingDetails?.settlementApproval === "pending" ||
              disabledStatus?.includes(bookingDetails?.moveOutStatus)
            }
            showViewBreakdownBtn
            handleEditPress={handleEditPress}
          >
            <TerminationDetail booking={bookingDetails} />
          </Collapse>

          <Collapse
            key="3"
            iKey="3"
            header="Payment Schedule"
            modalKey={modalPayload.iKey}
            handleEditPress={handleEditPress}
            disable={false}
            renewal={state?.renewal || bookingDetails?.propertyDetails?.usagesType == "Commercial"} // to hide change plan button for commercial
          >
            <PaymentSchedule newRenewalType={false} renewal={false} booking={bookingDetails} />
          </Collapse>

          <Collapse key="5" iKey="5" header="Documents" disable={disable}>
            <DocList
              booking={bookingDetails}
              handleGenerate={handleEditPress}
              parentState={updateState}
              disable={disable}
              sendSettlementReport={sendSettlementReport}
              setSendSettlementReport={setSendSettlementReport}
            />
          </Collapse>

          <Modal
            className="bd-modal"
            renewal={state?.renewal}
            updateState={updateState}
            modalPayload={modalPayload}
            setRenewalFormConfirm={setRenewalFormConfirm}
            renewalFormConform={renewalFormConform}
          />
        </SplitLayout.Content>

        <SplitLayout.Sider
          width="24%"
          className="ds-layout-sider"
          collapsible
          breakpoint="lg"
          collapsedWidth={0}
          trigger={null}
        >
          {organization?.enableChecklist && <Checklist />}
          {organization?.enableNotes && <Notes />}
          {organization?.enableTenantBankDetails && <TenantBankDetails />}
        </SplitLayout.Sider>
      </SplitLayout>
    </DashboardLayout>
  );
}

export default TerminationProcess;
